import React, { createContext, useContext } from 'react';

/** `undefined` means "not inside a named `platform.form`". */
const FormScopeContext = createContext<string | undefined>(undefined);

export interface FormScopeProviderProps {
  /** The enclosing `platform.form` name. Callers pass only a valid, non-blank name. */
  readonly name: string;
  readonly children: React.ReactNode;
}

export const FormScopeProvider: React.FC<FormScopeProviderProps> = ({
  name,
  children,
}) => (
  <FormScopeContext.Provider value={name}>{children}</FormScopeContext.Provider>
);

/** Name of the nearest enclosing `platform.form`, or `undefined` outside one. */
export function useFormScope(): string | undefined {
  return useContext(FormScopeContext);
}
